import { FragmentRemoteComponent as FragmentRemoteComponent$1 } from "@constructor/fragment/react";
import React, { useContext } from "react";
import { F as FragmentRemoteComponent } from "./FragmentRemoteComponentx.js";
import { f as federationContext } from "./inject.js";
function FragmentRemoteComponentCompat(options) {
  const federationRoot = useContext(federationContext);
  if (federationRoot) {
    return /* @__PURE__ */ React.createElement(FragmentRemoteComponent, { ...options });
  } else {
    return /* @__PURE__ */ React.createElement(FragmentRemoteComponent$1, { ...options });
  }
}
export {
  FragmentRemoteComponentCompat as F
};
//# sourceMappingURL=FragmentRemoteComponentCompatx.js.map
